'use client';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Title from '@/src/components/common/ui/text/Title.jsx';
import Next from '@/src/components/common/ui/buttons/Next.jsx';
import Prev from '@/src/components/common/ui/buttons/Prev.jsx';
import {Navigation, Grid, Autoplay, FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import useContainerOffset from '@/src/hooks/useContainerOffset.jsx';
import useDeviceTypeMobile from '@/src/hooks/useDeviceTypeMobile.jsx';
import { StyledPartners } from '@/src/components/common/eco/sections/partners/partner.style.js';
import LogoBox from '@/src/components/common/ui/single-item/LogoBox.jsx';
import Image from 'next/image';
import { useInView } from 'react-intersection-observer';
import SwiperCore from 'swiper';
SwiperCore.use([Autoplay]);
const Partners = ({ data }) => {
	const offset = useContainerOffset('.container')
	const isMobile = useDeviceTypeMobile()
	const prevRef = useRef(null);
	const nextRef = useRef(null);
	const containerRef = useRef(null);
	const [swiperInstance, setSwiperInstance] = useState(null);

	// Memoize the renderPatnerData function to prevent unnecessary re-renders
	const renderPatnerData = useMemo(() =>
			// eslint-disable-next-line react/display-name
			(e, index) => {
				return (
					<SwiperSlide key={index}>
						<LogoBox key={index} imgPath={e?.full_path} title={e?.shot_title}/>
					</SwiperSlide>
				);
			},
		[],
	);
	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					swiperInstance?.autoplay?.start();
				} else {
					swiperInstance?.autoplay?.stop();
				}
			},
			{ threshold: 0.1 } // Adjust this threshold as needed
		);

		if (containerRef.current) {
			observer.observe(containerRef.current);
		}

		return () => {
			if (containerRef.current) {
				observer.unobserve(containerRef.current);
			}
		};
	}, [swiperInstance]);


	return (
		<StyledPartners  className="partners" id={'partners'} ref={containerRef}>
			<Container>
				<Row>
					<Col md={12}>
						<div className="d-flex justify-content-between heading-title">
							<Title
								tag={'h2'}
								margin={'0 0 60px'}
								text={data?.section_data?.subtitle}
								color={'#fff'}
							/>

							{
								// !isMobile &&
								<div className="navigation d-flex gap-3 desktop-navigation">
									<Prev ref={prevRef} id={'partner_prev'} classCustom={'partner_prev'} />
									<Next ref={nextRef} id={'partner_next'} classCustom={'partner_next'} />
								</div>
							}


						</div>
					</Col>
				</Row>
			</Container>
			<Container fluid={true} className={'p-0 main-container'}>
				<Row>
					<Col md={4}>
						<div className="country-nation">
							<Image loading="lazy" width={'410'} layout="intrinsic" height={'205'} objectFit={'contain'} src={'/images/static/isolation_Mode.svg'} alt={'Partners Background'} />
						</div>
					</Col>
					<Col md={8} style={{ paddingRight: offset + 30 + 'px' }}>
						{
							data?.images?.list && data?.images?.list?.length > 0 &&
							<Swiper
								slidesPerView={5}
								grid={{
									rows: 3,
									fill: 'row', // Important for correct row filling
								}}
								spaceBetween={25}
								onSwiper={setSwiperInstance}
								loop={false}
								autoplay={{
									delay: 0,
									disableOnInteraction: false
								}}
								loopAddBlankSlides={false}
								cssMode={false}
								speed={1000}
								pagination={false}
								navigation={{
									prevEl:  ".partner_prev",
									nextEl:  ".partner_next",
								}}
								freeMode={false}
								breakpoints={{
									320: {
										slidesPerView: 3,
										spaceBetween: 30,
										freeMode: true,
										speed: 2000,
										loop:false,
										cssMode: false,
										loopAdditionalSlides: 2,
										grid: {
											rows: 2,
											fill: 'row', // Important for correct row filling
										}

									},
									768: {
										slidesPerView: 4,
										spaceBetween: 30,
										grid: {
											rows: 3,
											fill: 'row', // Important for correct row filling
										}
									},
									1024: {
										slidesPerView: 5,
										spaceBetween: 30,
										grid: {
											rows: 3,
											fill: 'row', // Important for correct row filling
										}
									},
								}}
								modules={[Navigation, Grid, Autoplay, FreeMode]}
								className="about-slider_mask w-slider-mask"
							>
								{

									data?.images?.list && data?.images?.list?.length > 0 &&
									data?.images?.list?.map((e, index) => renderPatnerData(e,index))

								}
							</Swiper>
						}


					</Col>
				</Row>
			</Container>

		</StyledPartners>
	);
};



export default React.memo(Partners);
